module.exports = __webpack_public_path__ + "static/media/Combined.274d9072.png";